import React from 'react'
import { IconFlag, IconFlag3 } from '@tabler/icons-react'
import { startCase } from 'lodash'
import classNames from 'classnames'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { ManualTaskForm } from './ManualTaskForm'

export const ManualTaskModal = ({
  callId,
  userId,
  organizationId,
  type,
  callType = 'call',
  messageId,
  // maxMinutes,
  // maxSeconds,
  onClose,
}) => {
  const title = type === 'compliance' ? 'Flag for Compliance' : 'Flag for Coaching'

  return (
    <ButtonAndFormModal
      icon={
        <IconFlag
          className={classNames({
            'status-critical': type === 'compliance',
            'status-success': type === 'coaching',
          })}
        />
      }
      buttonProps={{ small: true }}
      buttonLabel={startCase(type)}
      modalTitle={
        <div className="flex-align-center medium-gap">
          <IconFlag3
            className={classNames({
              'status-critical': type === 'compliance',
              'status-success': type === 'coaching',
            })}
          />
          <span>{title}</span>
        </div>
      }
      modalId={`manual-task/${type}/${callId}`}
      modalContent={
        <ManualTaskForm
          callId={callId}
          userId={userId}
          organizationId={organizationId}
          type={type}
          callType={callType}
          messageId={messageId}
          onClose={onClose}
        />
      }
      modalProps={{ size: 'tiny' }}
    />
  )
}
